export default function MySQL_COT() {
  return (
    <div>
      <h2>MySQL_COT</h2>    </div>
  );
}